<template>
    <div>
        <span class="dz-label">{{label}}</span>
        <v-input :error-messages="errors">
            <v-container class="dropzone" fluid grid-list-md @dragover.prevent @drop.prevent.stop="onDrop"
                         @click="$refs.fileDialog.click()">
                <v-layout row wrap class>
                    <v-flex xs12 class="text-xs-center">
                        <span class="dz-info">{{__('labels.dropzone_hint')}}</span>
                        <input type="file" class="hidden" ref="fileDialog" @change="onSelect"/>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-chip v-for="(item, index) in items" v-model="item.show" close color="secondary"
                                text-color="white" :key="index"
                                @input="removeItem(item)">{{item.file_name}}
                        </v-chip>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-input>
    </div>
</template>

<script>

    export default {
        name: 'Dropzone',
        props: {
            initialItems: {
                type: Array,
                default: function () {
                    return []
                }
            },
            label: String,
            item: Object,
            name: String,
            allowedTypes: {
                type: Array,
                default: () => {
                    return ['image/png', 'image/jpeg', 'application/pdf']
                }
            },
            maxSize: {
                type: String,
                default: '8MB'
            }
        },
        data: function () {
            return {
                items: this.initialItems.slice(),
                errors: [],
            }
        },
        computed: {
            maxBytes() {
                let maxSize = this.maxSize.toUpperCase();
                let matches = maxSize.match(/(\d+)(B|KB|MB|GB)/);
                if (!matches) {
                    return Math.pow(1024, 2) * 8;
                }
                let size = parseInt(matches[1]);
                let unit = matches[2];
                let units = ['B', 'KB', 'MB', 'GB'];
                return Math.pow(1024, _.indexOf(units, unit)) * size;
            },
        },
        watch: {
            initialItems: function () {
                this.items = this.initialItems.slice();
            },
            items: function () {
                this.errors = [];
            },
        },
        methods: {
            onSelect: function (e) {
                var files = e.target.files;
                this.addItems(files);
                e.target.value = '';
            },
            onDrop: function (e) {
                var files = e.dataTransfer.files;
                this.addItems(files);
            },
            addItems(files) {
                for (var i = 0; i < files.length; i++) {
                    let file = files.item(i);
                    let fileName = file.name;
                    let type = file.type;
                    let size = file.size;
                    if (_.indexOf(this.allowedTypes, type) === -1) {
                        this.errors = [this.__('errors.file_type')];
                        return;
                    } else if (size > this.maxBytes) {
                        this.errors = [this.__('errors.file_size')];
                        return;
                    }
                    if (typeof this.item[this.name + 'New'] === 'undefined') {
                        this.item[this.name + 'New'] = [];
                    }
                    this.item[this.name + 'New'].push(file);
                    this.items.push({file_name: fileName, file: file});
                }
            },
            removeItem(item) {
                if (this.initialItems.indexOf(item) === -1) {
                    this.item[this.name + 'New'].splice(this.item[this.name + 'New'].indexOf(item), 1);
                } else {
                    if (typeof this.item[this.name + 'Deleted'] === 'undefined') {
                        this.item[this.name + 'Deleted'] = [];
                    }
                    this.item[this.name + 'Deleted'].push(item.id);
                }
            }
        }
    }
</script>
